import { useState } from "react";
import { Button } from "./ui/button";
import { Textarea } from "./ui/textarea";

export default function LeakerInput({ onAddLeaker }) {
  const [name, setName] = useState("");
  const [role, setRole] = useState("");
  const [note, setNote] = useState("");

  const handleAdd = () => {
    if (!name || !role) return alert("Name and role are required");
    onAddLeaker({ name, role, note });
    setName("");
    setRole("");
    setNote("");
  };

  return (
    <div className="border border-gray-600 p-4 rounded mb-6 shadow-sm bg-gray-900">
      <h2 className="text-xl font-semibold mb-2 text-green-400 font-mono">Add Potential Leaker</h2>
      <div className="flex flex-col gap-2">
        <input
          type="text"
          placeholder="Name"
          className="p-2 border border-gray-600 rounded bg-gray-800 text-green-400 placeholder-gray-500 font-mono"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <input
          type="text"
          placeholder="Role / Title"
          className="p-2 border border-gray-600 rounded bg-gray-800 text-green-400 placeholder-gray-500 font-mono"
          value={role}
          onChange={(e) => setRole(e.target.value)}
        />
        <Textarea
          placeholder="Optional description or message..."
          rows={3}
          value={note}
          onChange={(e) => setNote(e.target.value)}
          className="bg-gray-800 border-gray-600 text-green-400 placeholder-gray-500 font-mono"
        />
        <Button onClick={handleAdd}>Add</Button>
      </div>
    </div>
  );
}